import { useMutation } from '@tanstack/react-query'
import { addFunctionalScore  } from '../services/fuctional_checklist'

const AddFunctionalChecklistScore = () => {
 const functionalChecklistScore = useMutation({
    queryKey:['functional_checklist'],
    mutationFn: addFunctionalScore
 })
 return functionalChecklistScore;
}

export default AddFunctionalChecklistScore